module.exports = __webpack_public_path__ + "static/media/bn.02ecb4b4.svg";